import {SESSION_STORAGE_ACTIVE_DEPT_NAME} from "../../config/constants"

const addDeptToSessionStorage = (target, department) => {
    sessionStorage.setItem(SESSION_STORAGE_ACTIVE_DEPT_NAME, JSON.stringify({path: target, dept: department}))
    // User Story 45843 - Remove localStorage references for "primaryNavDeptSelector" [Repo's: GTM, Header, Meganav, PLP]
    localStorage.setItem(SESSION_STORAGE_ACTIVE_DEPT_NAME, JSON.stringify({path: target, dept: department}))
}

const removeDeptFromSessionStorage = () => {
    sessionStorage.removeItem(SESSION_STORAGE_ACTIVE_DEPT_NAME)
    // User Story 45843 - Remove localStorage references for "primaryNavDeptSelector" [Repo's: GTM, Header, Meganav, PLP]
    localStorage.removeItem(SESSION_STORAGE_ACTIVE_DEPT_NAME)
}

export {addDeptToSessionStorage, removeDeptFromSessionStorage}
